import DOMPurify from "dompurify";

export function sanitizeHtml(html: string) {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "p",
      "br",
      "b",
      "strong",
      "i",
      "em",
      "u",
      "a",
      "ul",
      "ol",
      "li",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "blockquote",
      "code",
      "pre",
      "hr",
      "span",
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "title", "style"],
    ALLOW_DATA_ATTR: false,
  });
}
